import { AnalysisResult, CoreAnalysisEngine } from "./coreAnalysisEngine";
import { ReactElement } from "react";
import { TFunction } from "i18next";
import { EngineType } from "../types";
import { ResultCo21 } from "../components/molecules/ResultCo21";

export type Co21AnalysisResult = AnalysisResult<"co2.1">;
export type Co21PastDataItem = {
  id: number;
  recording_id: string;
  analyzed_at: string;
  analysis_result: AnalysisResult<"co2.1">["analysis_result"];
};

export type Co21DetailedAnalysisResult = {
  details: Record<string, unknown>;
  ninety_day_average_past_data: Co21PastDataItem[];
  sub_scores: {
    Co1: number;
    Co2_Sub: number;
    Cog: number;
    Cog_probs: number;
    cds: number;
    he: number;
    mci: number;
  };
};

export class Co21Engine extends CoreAnalysisEngine<"co2.1"> {
  _engineType: EngineType = "co2.1";

  constructor() {
    super("co2.1");
  }

  async renderResult(
    key: number,
    fileId: string,
    t: TFunction,
  ): Promise<ReactElement> {
    const result = await this.getResult(fileId);
    if (!result) {
      // TODO: getResult失敗時のフォールバックUIを用意する
      return <></>;
    }

    // Determine message based on decision
    const getMessageKey = (decision: string): string => {
      switch (decision) {
        case "A":
          return "PJ.Co21Result.MessageA";
        case "B":
          return "PJ.Co21Result.MessageB";
        case "C":
          return "PJ.Co21Result.MessageC";
        default:
          return "PJ.Co21Result.MessageB";
      }
    };

    return (
      <ResultCo21
        key={key}
        title={t("Result.Dementia_analysis_result")}
        averageScore={result.analysis_result.ninety_day_average.cognitive_score}
        currentScore={result.analysis_result.cognitive_score}
        message={t(
          getMessageKey(result.analysis_result.ninety_day_average.decision),
        )}
        description={t("PJ.Co21Result.Description")}
        co21Result={result}
      />
    );
  }
}
